import { events } from '../../events';
import { BaseComponent } from '../../framework/base.component';
import { component } from '../../framework/component.decorator';
import { OnInit } from '../../framework/on-init.interface';
import { button$ } from '../../framework/templating/button.element';
import { icon$ } from '../../framework/templating/icon.element';
import styles from './source-selector.component.scss';

@component({
  selector: 'app-source-selector',
  styles,
})
export class SourceSelectorComponent
  extends BaseComponent<SourceSelectorComponent>
  implements OnInit
{
  async createInitialComponent(): Promise<HTMLElement | HTMLElement[]> {
    return button$(
      {
        onCreate: (element) => {
          element.title = 'Click to select source';

          element.addEventListener('click', () => events.emit('select-source'));
        },
      },
      [icon$('camera-video-fill')]
    );
  }

  async onInit() {
    events.on(
      ['stop-recording', 'user-denied-access', 'recording-cancelled'],
      () => {
        this.doOnFirstChild<HTMLButtonElement>((btn) => (btn.disabled = false));
      }
    );

    events.on(['start-recording', 'select-source'], () => {
      this.doOnFirstChild<HTMLButtonElement>((btn) => (btn.disabled = true));
    });
  }
}
